import PropTypes from 'prop-types';
import React from 'react';

import Button from '../Button';

import { srOnly } from '../../base-styles/mixins.module.css';
import styles, { buttonContainer, container, invisible, link as linkStyle } from './styles.module.css';

/**
 * Button with dropdown menu presentational component.
 */
const ButtonDropdown = ({
  buttonVisible,
  children,
  className,
  dropdownDirection,
  dropdownVisible,
  label,
  onClick,
  onLinkClick,
  ...props
}) => (
  <div className={[container, className].join(' ')} {...props}>
    <div className={buttonContainer}>
      <Button
        className={buttonVisible ? '' : invisible}
        onClick={onClick}
        aria-haspopup="true"
        aria-hidden={!buttonVisible}
        aria-expanded={dropdownVisible}
      >
        {buttonVisible
         ? label
         : <span className={srOnly}>{label}</span>}
      </Button>
    </div>
    {dropdownVisible &&
      <ul className={dropdownDirection.map(directionStyle => styles[directionStyle]).join(' ')}>
        {[].concat(children).map(link => (
          <li key={link.props.to}>
            {React.cloneElement(link, { className: [linkStyle, link.props.className].join(' '), onClick: onLinkClick })}
          </li>
        ))}
      </ul>}
  </div>
);

ButtonDropdown.propTypes = {
  /**
   * Boolean whether to show visible button.
   */
  buttonVisible: PropTypes.bool,
  /**
   * Children (Link components) to append to dropdown.
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  /**
   * String class names to append to component styles.
   */
  className: PropTypes.string,
  /**
   * Array of strings matching media-query styles to determine direction of dropdown.
   */
  dropdownDirection: PropTypes.arrayOf(
    PropTypes.oneOf([
      'downSM',
      'downMD',
      'upSM',
      'upMD',
      'downLeftSM',
      'downLeftMD',
      'downRightSM',
      'downRightMD',
    ]),
  ),
  /**
   * Boolean whether to show dropdown.
   */
  dropdownVisible: PropTypes.bool,
  /**
   * String label for the button.
   */
  label: PropTypes.string.isRequired,
  /**
   * Function to call on button click.
   */
  onClick: PropTypes.func,
  /**
   * Function to call on link click.
   */
  onLinkClick: PropTypes.func,
};

ButtonDropdown.defaultProps = {
  buttonVisible: true,
  className: '',
  dropdownDirection: ['downSM'],
  dropdownVisible: false,
  onClick: () => {},
  onLinkClick: () => {},
};

export default ButtonDropdown;
